import Form from "Scripts/common/form";
import Steps from 'Scripts/donate-form/steps';

import { 
    enableTomSelects, 
    enableLoqate, 
    enablePostcodeLabelToggle 
} from 'Scripts/donate-form/address-utils';

import { 
    enableParsleyPostcodeValidator, 
    enableParsleyBlocklistValidator, 
    enableParsleyNotEmailValidator, 
    enableParsleyNotHtmlValidator,
    scrollToParsleyError,
} from 'Scripts/common/parsley-utils';

export default class QuickDonateForm {
    constructor() {
        this.ui = {
            // Containers
            form: $('.js-quick-donate-form'),
            buttonNext: $('.js-next-step'),
            buttonPrev: $('.js-prev-step'),
            // Details screen
            screenName: $('#name'),
            makeAnon: $('.js-make-anon'),
            msgInput: $('#message'),
            presetMsgs: $('.js-preset-messages'),

            // Gift Aid
            giftAidInd: $('#giftAidEnabled'),
            giftAidCheckbox: $('input[name="giftAid"]'),
            giftAidRemove: $('.js-remove-giftaid'),
            giftAidStatement: $('.js-giftaid-statement'),
            giftAidAnswer: $('.js-giftaid-statement-answer'),
            giftAidAddress: $('.js-giftaid-address'),
            giftAidAddressFields: $('.js-giftaid-address input, .js-giftaid-address select'),
            giftAidContainer: $(".js-giftaid-address-fields-container"),
        }

        new Form({
            form: this.ui.form,
            preCheck: this.onSubmit.bind(this),
            callback: this.afterSubmit.bind(this),
            onError: this.showDeclinedScreen.bind(this),
        });

        // Manages stepping between screens
        this.steps = new Steps();

        this.setupParsley();
        this.bindEvents();
        this.setupAddressUtils();
    }

    bindEvents() {
        // Next and prev buttons
        this.ui.buttonNext.on('click', this.goToNextStep.bind(this));
        this.ui.buttonPrev.on('click', this.goToPrevStep.bind(this));

        // Details screen
        this.ui.makeAnon.on('change', this.onToggleAnon.bind(this));
        this.ui.msgInput.on('change keyup', this.onUpdateMsg.bind(this));
        this.ui.presetMsgs.on('click', 'button', this.onClickPresetMsg.bind(this));

        // Gift Aid screen
        this.ui.giftAidCheckbox.on('change', this.onToggleGiftAid.bind(this));
        this.ui.giftAidAnswer.on('change', this.onGiftAidAnswer.bind(this));
        this.ui.giftAidContainer.on('show.bs.collapse', this.onGiftAidContainerShown.bind(this)); 
        this.ui.giftAidRemove.on('click', this.onRemoveGiftAid.bind(this));

        // Bind form validation
        this.ui.form.parsley({
            excluded: ':disabled',
            errorsContainer: function(field) {
                var $el = field.$element;
                return $el.closest('.form-group').find('.error-container');
            }
        });

        // Scroll to first form error
        this.ui.form.parsley().on('form:error', (e) => {
            scrollToParsleyError(e, ".js-step.show", ".box__content");
        });
    }

    setupParsley() {
        enableParsleyPostcodeValidator();
        enableParsleyBlocklistValidator();
        enableParsleyNotEmailValidator();
        enableParsleyNotHtmlValidator();
    }

    setupAddressUtils(){
        enableTomSelects([
            "#country", 
        ]);

        enableLoqate([
            "#giftaid-loqate",
        ]); // Needs to be after enableTomSelects

        enablePostcodeLabelToggle();
    }

    //
    // Event handler functions
    //

    // Toggle between first name and 'Anonymous'
    onToggleAnon(event) {
        const toggle = $(event.currentTarget);

        if( toggle.is(":checked") ){
            this.ui.screenName.val('Anonymous');
        } else if (this.ui.screenName.val() == 'Anonymous') {
            this.ui.screenName.val(toggle.data('default'));
        }
    }

    onUpdateMsg(event) {
        this.ui.presetMsgs.collapse(this.ui.msgInput.val().length ? 'hide' : 'show');
    }

    onClickPresetMsg(event) {
        const selectedMsg = $(event.currentTarget);
        this.ui.msgInput.val(selectedMsg.html());
        this.ui.presetMsgs.find('button').attr('aria-selected', false).removeClass('active');
        selectedMsg.attr('aria-selected', true).addClass('active');
    }

    isGiftAidSelected() {
        console.log("DonateForm.isGiftAidSelected", this.ui.giftAidCheckbox.filter(":checked").val() == "Y");
        return this.ui.giftAidCheckbox.filter(":checked").val() == "Y";
    }

    onToggleGiftAid() {
        const giftAidSelected = this.isGiftAidSelected();

        // Enable/disable GiftAid statements
        $(this.ui.giftAidAnswer).each((i, answer) => {
            $(answer).prop("disabled", !giftAidSelected).prop("required", giftAidSelected).prop('checked', false);
        });

        // Show statement
        this.ui.giftAidStatement.collapse(giftAidSelected ? 'show' : 'hide');

        // Hide address if it's already been shown
        if(!giftAidSelected) {
            this.ui.giftAidAddress.collapse('hide');
            this.ui.giftAidAddressFields.prop('disabled',true).prop('required',false);
            this.ui.giftAidInd.val(false);
        }
    }

    onRemoveGiftAid() {
        console.log("Donate.onRemoveGiftAid");
        $("#giftAidN").prop("checked", true).trigger("change");
    }

    onGiftAidAnswer() {
        const unconfirmedAnswers = $(this.ui.giftAidAnswer).not(":checked").length;

        // If all answers have been confirmed, show the address fields, otherwise hide them
        if(unconfirmedAnswers == 0){    
            this.ui.giftAidAddressFields.each((i, field) => {
                $(field).prop("disabled", false).prop("required", !$(field).hasClass('js-not-required'));
            });

            // Show address
            this.ui.giftAidAddress.collapse('show');

            // Set the Gift Aid hidden input to true
            this.ui.giftAidInd.val(true);
        } else {
            this.ui.giftAidAddress.collapse('hide');
            this.ui.giftAidAddressFields.prop('disabled',true).prop('required',false);
            this.ui.giftAidInd.val(false);
        }
    }

    onGiftAidContainerShown() {
        this.ui.form.parsley().reset();
        $("#giftaid-address-shown").val("true");
    }

    //
    // Core functions
    //

    isFormValid(currentStep) {
        const parsleyArgs = currentStep ? { group: 'step-' + currentStep } : {};
        this.ui.form.parsley().validate(parsleyArgs);
        return this.ui.form.parsley().isValid(parsleyArgs);
    }

    goToNextStep(e) {
        e.preventDefault();

        const currentStep = this.steps.getCurrent();
        const nextStep = this.steps.getNext();

        console.log("QuickDonateForm.goToNextStep", currentStep, nextStep);

        if(this.isFormValid(currentStep)) {
            this.steps.goToStep(nextStep);
        } else { // This is here as we trigger this function when the user clicks browser forward button
            this.steps.goToStep(currentStep);
        }
    }

    goToPrevStep(e) {
        e.preventDefault();

        const currentStep = this.steps.getCurrent();
        const prevStep = this.steps.getPrev();

        console.log("QuickDonateForm.goToPrevStep", currentStep, prevStep);

        this.steps.goToStep(prevStep);
    }

    onSubmit(e) {
        console.log("QuickDonateForm.onSubmit");
        return this.isFormValid(this.steps.getCurrent());
    }

    afterSubmit(resp) {
        console.log("QuickDonateForm.afterSubmit", resp);

        if (resp.success) {
            this.showThankyouScreen();
        } else {
            this.showDeclinedScreen();
        }
    }

    showThankyouScreen() {
        console.log("QuickDonateForm.showThankyouScreen");
        this.steps.goToStep('success');
    }

    showDeclinedScreen() {
        console.log("QuickDonateForm.showDeclinedScreen");
        this.steps.goToStep('failed');
    }
}